import React, { FunctionComponent } from "react"
import { Controller } from "react-hook-form"
import FormInput from "../../../components/Form/Inputs/FormInput"
import Textarea from "../../../components/Form/Inputs/Textarea"
import Upload from "../../../components/Upload/Upload"
import { iUserBusiness } from "../../../definitions/User"

interface iProps {
  item: iUserBusiness
}

const BusinessOverview: FunctionComponent<iProps> = ({ item }) => {
  return (
    <div className="d-flex">
      <div className="col-4">
        <FormInput name="title" label={"Title"} />
        <FormInput name="url" label={"Url"} />
        <FormInput name="website" label={"Website"} />
        <FormInput name="phone" label={"Phone number"} />
        <Controller as={Textarea} name="description" label={"Description"} />
      </div>
      <div className="col-8 d-flex">
        <div className="col-5">
          <Upload
            name={"logo"}
            fileCollection={"Files_BusinessLogos"}
            maxFiles={1}
            initialFiles={[item?.logo || ""]}
            fileType={["image/png", "image/jpeg"]}
            label="Upload Logo"
          />
        </div>
        <div className="col-7">
          <Upload
            name={"cover"}
            fileCollection={"Files_BusinessCovers"}
            maxFiles={1}
            initialFiles={[item?.cover || ""]}
            fileType={["image/png", "image/jpeg"]}
            label="Upload Cover"
          />
        </div>
      </div>
    </div>
  )
}

export default BusinessOverview
